// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components

import SvgIconStyle from "../../../components/SvgIconStyle";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  dashboard: getIcon("ic_dashboard"),
  master: getIcon("ic_master"),
  parent: getIcon("ic_parent"),
  report: getIcon("ic_report"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
      },
    ],
  },
];
 const navConfigTuckShop = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
      },
      {
        title: "Tuckshop",
        path: PATH_DASHBOARD.general.createOrder,
        icon: ICONS.ecommerce,
      },
    ],
  },
];

export const getNavConfigTuckShop = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const branchIDs = user?.branchID?.split(",") || [];
  const showReports =
    branchIDs.length > 1 || (branchIDs.length === 1 && branchIDs[0] !== "0");
  let config = [...navConfig]; // Start with default navConfig
  if (user.tuckshop === 1) {
    config = [...navConfigTuckShop]; // if tuckshop enable
  }

  if (showReports) {
    config.push({
      subheader: "Reports",
      items: [
        {
          title: "Order Reports",
          path: PATH_DASHBOARD.reports.root,
          icon: ICONS.report,
          children: [
            {
              title: "Student Wise Pending Order",
              path: PATH_DASHBOARD.reports.studentwisependingReport,
            },
            {
              title: "School Wise Pending Order",
              path: PATH_DASHBOARD.reports.schoolwisependingReport,
            },
            {
              title: "Product Order",
              path: PATH_DASHBOARD.reports.dateWiseReport,
            },
            {
              title: "Order Wise GST",
              path: PATH_DASHBOARD.reports.orderWiseGSTReport,
            },
            {
              title: "With GST",
              path: PATH_DASHBOARD.reports.salesWithGst,
            },
            {
              title: "Without GST",
              path: PATH_DASHBOARD.reports.salesWithOutGst,
            },
            {
              title: "Shipping",
              path: PATH_DASHBOARD.reports.shippingReport,
            },
            {
              title: "Sales",
              path: PATH_DASHBOARD.reports.salesReport,
            },
          ],
        },
      ],
    });
  }

  return config;
};

export default navConfig;
